<section class="background-overlay" [class.hidden]="!overlayState.isActive ">
  <div class="content">
    <div class="overlay-contact">
      <div class="d-flex">
        <div class="add-contact">       
            <img  class="mobile-image" (click)="resetNewContactInput();" src="assets/img/add-contacts/user-image.svg" alt="" />
          @switch (overlayState.AddOrEditState) {
          @case("addContact"){
            <img class="mobile-close" (click)="toggleOverlay() ;resetNewContactInput();contactForm.resetForm()" src="assets/img/add-contacts/mobile-close.svg" />
          }@case("editContact"){
            <img class="mobile-close" (click)="toggleOverlay() ;resetNewContactInput()" src="assets/img/add-contacts/mobile-close.svg" />
          }
          }

          <div class="center-contact">
            <img src="assets/img/add-contacts/join-logo.svg" />
            @switch (overlayState.AddOrEditState) {
            @case ("addContact") {
            <h2>Add contact</h2>
            <span>Task are better with a team!
              <div class="blue-line"></div>
            </span> }
            @case ("editContact") {
            <h2>Edit contact</h2>
            } }
          </div>
        </div>
        <div class="user-data">
          @switch (overlayState.AddOrEditState) {
          @case("addContact"){
          <div class="close-image" (click)="toggleOverlay() ;resetNewContactInput();contactForm.resetForm() ">
            <img src="assets/img/add-contacts/Vector.svg" />
          </div>
          }@case("editContact"){
          <div class="close-image" (click)="toggleOverlay() ;resetNewContactInput()">
            <img src="assets/img/add-contacts/Vector.svg" />
          </div>
          }
          }
          <div class="user-image">
            <img src="assets/img/add-contacts/user-image.svg" />
          </div>
          <div class="user-contact-data">

            <form class="contact-form" #contactForm="ngForm">
              @switch (overlayState.AddOrEditState) {
              @case ('addContact') {
                <div class="inputAreas">
                  <input [(ngModel)]="contactList.firstName" class="user" type="text" placeholder="Name" name="name"
                  required pattern="^([a-zA-ZäöüÄÖÜß]+\.?(-[a-zA-ZäöüÄÖÜß]+\.?)*\s+)+[a-zA-ZäöüÄÖÜß]+\.?(-[a-zA-ZäöüÄÖÜß]+\.?)*$" id="name" #name="ngModel"
                  [class.invalid]=" name.invalid && name.dirty " maxlength="30"/>
                  <div class="invalid-input">
                  @if (name.invalid && name.dirty) {
                  <div>Example: firstname lastname</div>
                  }
                </div>
              </div>

              <div class="inputAreas">
                <input [(ngModel)]="contactList.email" class="mail" type="email" placeholder="Email" name="email" required
                  pattern="[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}" id="mail" #mail="ngModel"
                  [class.invalid]=" mail.invalid && mail.dirty " maxlength="30"/>
                <div class="invalid-input">
                  @if (mail.invalid && mail.dirty) {
                  <div>Example: name&#64;example.com</div>
                  }
                </div>
              </div>

              <div class="inputAreas">
                <input [(ngModel)]="contactList.phone" class="phone" type="text" placeholder="Phone"
                name="phone" required pattern="^\+[0-9]{6,15}$" id="phone" #phone="ngModel"
                [class.invalid]=" phone.invalid && phone.dirty " (input)="addPrefix()" maxlength="15" (keypress)="allowOnlyNumbersAndPlus($event)"/>
              <div class="invalid-input">
                @if (phone.invalid && phone.dirty) {
                <div>Example: +49301234567</div>
                }
              </div>
              </div>

              } @case ('editContact') {
              @if (overlayState.selectedUser) {
              <input [(ngModel)]="overlayState.fullNameForEdit" class="user" type="text" placeholder="Name" name="name"
                required pattern="^([a-zA-ZäöüÄÖÜß]+\.?(-[a-zA-ZäöüÄÖÜß]+\.?)*\s+)+[a-zA-ZäöüÄÖÜß]+\.?(-[a-zA-ZäöüÄÖÜß]+\.?)*$" id="name" #name="ngModel"
                [class.invalid]=" name.invalid && name.dirty " maxlength="30"/>
              <div class="invalid-input">
                @if (name.invalid && name.dirty) {
                <div>Example: firstname lastname</div>
                }
              </div>

              <input [(ngModel)]="overlayState.selectedUser.email" class="mail" type="email" placeholder="Email"
                name="email" required pattern="[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}" id="mail"
                #mail="ngModel" [class.invalid]=" mail.invalid && mail.dirty " maxlength="30"/>
              <div class="invalid-input">
                @if (mail.invalid && mail.dirty) {
                <div>Example: name&#64;example.com</div>
                }
              </div>

              <input [(ngModel)]="overlayState.selectedUser.phone" class="phone" type="text" placeholder="Phone"
                name="phone" required pattern="^\+[0-9]{6,15}$" id="phone" #phone="ngModel"
                [class.invalid]=" phone.invalid && phone.dirty " (input)="addPrefix()" maxlength="15" (keypress)="allowOnlyNumbersAndPlus($event)"/>
              <div class="invalid-input">
                @if (phone.invalid && phone.dirty) {
                <div>Example: +49301234567</div>
                }
              </div>
              }
              }
              }
            </form>

            <div class="cancel-create-contact">
              @switch (overlayState.AddOrEditState) {
              @case ("addContact") {
              <button (click)="toggleOverlay();  resetNewContactInput(); contactForm.resetForm();" class="cancel">
                Cancel
                <img src="assets/img/add-contacts/Vector.svg" />
              </button>
              <button class="create" [disabled]="!contactForm.valid"
                (click)=" splitFullName(); checkAndAdd(contactList);  overlayState.contactConfirmation(); resetNewContactInput(); toggleOverlay(); contactForm.resetForm();">
                Create contact
                <img src="assets/img/add-contacts/check.svg" />
              </button>
              } @case ("editContact") {
              <button class="cancel">Delete</button>
              <button class="create" (click)="overlayState.updateContact();  toggleOverlay();"
                [disabled]="!contactForm.valid">
                Save
                <img src="assets/img/add-contacts/check.svg" />
              </button>
              }
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
